import { FourDService, Transform } from '4d-mapper';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MainService } from '../main.service';

@Component({
  selector: 'app-sharable',
  templateUrl: './sharable.component.html',
  styleUrls: ['./sharable.component.scss']
})

export class SharableComponent implements OnInit {

  loading:boolean = true;

  transforms:any = null;

  V:any = null;

  constructor(public dialogRef: MatDialogRef<SharableComponent> , public mainService: MainService, public fourD: FourDService ) { 
    this.V = this.fourD.V;
  }

  ngOnInit() {

    let me = this;

    this.getTransforms();
  
    // setTimeout( () => { me.loading = false; }, 3000 );
  }

  getTransforms() {

    let wms = this.fourD.transformTypes.find(t => t.uid == 'WMS');
    let wmsCheck = this.fourD.transformTypes.find(t => t.uid == 'wms_check');

    if ( wms && wmsCheck ) {

      let types = this.fourD.transformTypes.find(t => t.uid == 'WMS').id + '|' + this.fourD.transformTypes.find(t => t.uid == 'wms_check').id;
      const q = this.fourD.V.searchByObject(Transform).equals('account',this.fourD.activeTeam).equals('transformType',types).queryObservable().subscribe(res => {
        if(res.items.length) {
          this.transforms = res.items;
        }
        this.loading = false;
      },
      e => {
        this.loading = false;
      });

    } else {
      this.loading = false;
    }

  }


}
